/* ============================================================
   ps-page-faq.js — P.S. beauty by peakspan
   Behaviour for templates/page.faq.liquid only.

   1. Single-open accordion (fallback for browsers without the
      native exclusive <details name="..."> grouping).
   2. Deep links: /pages/faq#q-eye-safety opens and reveals that row.
   3. Sticky category jump row highlights the section in view.
   4. Alternating left/right reveals for the category blocks and
      the hero stat tiles (the shared observers in ps-motion.js /
      ps-chapters.js do not know these selectors).

   Additive only. No JS at all => every row is a normal <details>,
   all content reachable. Reduced motion => no movement.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('.psf');
  if (!root) { return; }

  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { reduced = false; }

  var hasIO = 'IntersectionObserver' in window;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  var rows = root.querySelectorAll('details.psf-q');

  /* ----------------------------------------------------------
     1 · SINGLE-OPEN
     Native <details name> already does this where supported; this
     is the fallback and it is idempotent either way.
     ---------------------------------------------------------- */
  each(rows, function (row) {
    row.addEventListener('toggle', function () {
      if (!row.open) { return; }
      each(rows, function (other) {
        if (other !== row && other.open) { other.open = false; }
      });
    });
  });

  /* ----------------------------------------------------------
     2 · DEEP LINKS — #q-… opens the row
     ---------------------------------------------------------- */
  function openFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) { return; }
    var target;
    try { target = root.querySelector(hash); } catch (err) { target = null; }
    if (!target) { return; }
    var row = target.closest ? target.closest('details.psf-q') : null;
    if (!row) { return; }
    row.open = true;
    each(rows, function (other) {
      other.classList.remove('is-target');
    });
    row.classList.add('is-target');
    window.setTimeout(function () {
      row.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    }, 60);
  }
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  /* ----------------------------------------------------------
     3 · JUMP ROW SCROLLSPY
     ---------------------------------------------------------- */
  var chips = root.querySelectorAll('.psf-chip[data-psf-jump]');
  if (chips.length && hasIO) {
    var byId = {};
    var sections = [];
    each(chips, function (chip) {
      var id = chip.getAttribute('data-psf-jump');
      var sec = id ? document.getElementById(id) : null;
      if (!sec) { return; }
      byId[id] = chip;
      sections.push(sec);
    });

    var visible = {};
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        visible[en.target.id] = en.isIntersecting;
      });
      var currentId = null;
      for (var i = 0; i < sections.length; i++) {
        if (visible[sections[i].id]) { currentId = sections[i].id; break; }
      }
      each(chips, function (chip) {
        chip.classList.toggle(
          'is-current',
          currentId !== null && chip.getAttribute('data-psf-jump') === currentId
        );
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

    sections.forEach(function (sec) { spy.observe(sec); });

    /* keep the active chip in view inside the horizontal strip */
    var strip = root.querySelector('.psf-jump-inner');
    if (strip) {
      each(chips, function (chip) {
        chip.addEventListener('click', function () {
          each(chips, function (c) { c.classList.remove('is-current'); });
          chip.classList.add('is-current');
        });
      });
    }
  }

  /* ----------------------------------------------------------
     4 · ALTERNATING LEFT / RIGHT REVEALS
     ---------------------------------------------------------- */
  if (reduced || !hasIO) { return; }

  var revealEls = [];
  ['.psf-stat', '.psf-cat', '.psf-note'].forEach(function (sel) {
    each(root.querySelectorAll(sel), function (el, i) {
      if (el.classList.contains('psm-left') || el.classList.contains('psm-right')) { return; }
      el.classList.add(i % 2 === 0 ? 'psm-left' : 'psm-right');
      revealEls.push(el);
    });
  });

  if (!revealEls.length) { return; }

  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) { return; }
      var el = en.target;
      var siblings = Array.prototype.filter.call(
        el.parentElement ? el.parentElement.children : [],
        function (c) {
          return c.classList.contains('psm-left') || c.classList.contains('psm-right');
        }
      );
      var idx = siblings.indexOf(el);
      window.setTimeout(function () { el.classList.add('psm-in'); }, Math.max(0, idx) * 90);
      revealIO.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

  revealEls.forEach(function (el) { revealIO.observe(el); });

  /* safety net — never leave content stuck at opacity 0 */
  window.setTimeout(function () {
    revealEls.forEach(function (el) { el.classList.add('psm-in'); });
  }, 4000);
})();
